import { Component, OnInit } from '@angular/core';
import { CognitoAuthService } from '@techspert-io/auth';

@Component({
  selector: 'app-not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
  standalone: false,
})
export class NotAuthorizedComponent implements OnInit {
  constructor(private auth: CognitoAuthService) {}

  ngOnInit(): void {
    this.auth.setRedirectUrl(null);
  }

  logout(): void {
    this.auth.logOut().subscribe();
  }
}
